import _ from "lodash";
import moment from "moment";

_.mixin({
  mergeById: function mergeById(arr, obj, idProp, initial) {
    const index = _.findIndex(arr, function(elem) {
      // double check, since undefined === undefined
      return typeof elem[idProp] !== "undefined" && elem[idProp] === obj[idProp];
    });
    if (index > -1) {
      arr[index] = obj;
    } else {
      if (initial) {
        arr.unshift(obj);
      } else {
        arr.push(obj);
      }
    }
    return arr;
  }
});

export const getWeekRangeDates = (weekNo, monthNo) => {
  const firstDay = moment()
    .month(monthNo)
    .startOf("month")
    .day();
  const firstWeek = moment()
    .month(monthNo)
    .startOf("month")
    .week();
  const firstWeekDay = firstDay === 0 ? 7 : firstDay;
  const weekStart = moment()
    .month(monthNo)
    .startOf("month")
    .add(weekNo - firstWeek, "weeks")
    .add(1 - firstWeekDay, "days");
  const weekEnd = moment(weekStart).add(6, "days");
  [weekStart, weekEnd];

  const dates = [];
  let currentDate = weekStart;
  while (currentDate <= weekEnd) {
    dates.push(moment(currentDate).format("DD"));
    currentDate = moment(currentDate).add(1, "days");
  }
  return { dates, range: [weekStart, weekEnd] };
};

// get percentage of a number

export const getPercentage = (newValue, oldValue) => {
  if (oldValue == 0) return 0;
  else if (oldValue > 0) return Math.round(((newValue - oldValue) / oldValue) * 100);
  return 100;
};
